/* Fills the page's visible region (the viewport minus PageLayout's 48px
   header and the gutter above and below its content) and puts its own content
   in the middle of it. */
.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  min-height: var(--page-content-height);
  text-align: center;
}

.spinner {
  color: var(--gray-9);
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-3xl);
  height: var(--spacing-3xl);
  border-radius: 50%;
  background: var(--gray-3);
  color: var(--gray-11);
}

.icon svg {
  width: var(--spacing-lg);
  height: var(--spacing-lg);
}

.title {
  margin: var(--spacing-xs) 0 0;
  color: var(--gray-12);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.body {
  max-width: 32rem;
  margin: 0;
  color: var(--gray-11);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  overflow-wrap: anywhere;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-sm);
  margin-top: var(--spacing-sm);
}

.actions:empty {
  display: none;
}
